export const PATH_AGENCY = "/agency";

export function fetchAgencyMemberGradeGrpPaymt(
    {
        agncyCode,
        bsnDate,
        benTrget,
    }
) {
    return this.http.get(`${PATH_AGENCY}/member-grade-grp-paymt`, {
        params: {
            agncyCode,
            bsnDate,
            benTrget,
        },
    });
}